var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M139.5 115.004C139.5 116.014 137.865 116.976 134.869 117.865C125.071 120.798 100.614 122.867 72.0071 122.867C55.0056 122.867 39.4636 122.134 27.6015 120.92C25.6569 120.716 23.8074 120.512 22.0769 120.283C11.1656 118.89 4.5 117.039 4.5 114.98C4.5 113.261 9.1926 111.687 17.1514 110.4C22.1958 109.584 28.5855 108.875 35.9453 108.331C39.4778 108.069 43.2147 107.841 47.1323 107.656C50.1085 107.525 53.1799 107.404 56.3463 107.321C60.7298 107.2 65.2511 107.127 69.9389 107.117H71.9738C82.6521 107.117 92.7409 107.404 101.722 107.923C103.034 108.006 104.327 108.079 105.578 108.176C106.41 108.225 107.213 108.283 108.045 108.346C115.405 108.875 121.795 109.584 126.868 110.415C134.798 111.712 139.49 113.29 139.49 114.995V115.004H139.5Z",
    fill: "#14181C",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1328 50.3828H62.9766V104.97H83.1328V50.3828Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4216 104.422L65.2417 26.5327C68.2062 21.1558 75.9242 21.1558 78.8886 26.5327L121.709 104.422C124.554 109.613 120.809 115.956 114.885 115.956H29.2402C23.3161 115.956 19.5523 109.599 22.4168 104.422H22.4216ZM77.9084 94.5529C77.9084 91.322 75.2961 88.7097 72.0652 88.7097C68.8343 88.7097 66.2219 91.322 66.2219 94.5529C66.2219 97.7838 68.8343 100.396 72.0652 100.396C75.2961 100.396 77.9084 97.7838 77.9084 94.5529ZM68.1729 77.028C68.1729 79.174 69.9192 80.9203 72.0652 80.9203C74.2112 80.9203 75.9575 79.174 75.9575 77.028V57.5569C75.9575 55.4109 74.2112 53.6647 72.0652 53.6647C69.9192 53.6647 68.1729 55.4109 68.1729 57.5569V77.028Z",
    fill: "#D40C74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon-error.64f8082f2f85f2447b9721e57830a463.svg";
export { ForwardRef as ReactComponent };